//App urls

export const RoutesUrls = {
  root: "/",
  admin: "/admin",
  ministryAdmin: "/ministry",
  districtAdmin: "/district",
  provinceAdmin: "/province",
  userConfirmation: "/user-confirmation",
  pouAdmin: "/pou",
};

//super admin url

export const adminRoutes = {
  //dashboard urls

  root: `/`,
  dashboard: `/dashboard`,
  seemoreDashboard: `/dashboard/SeeMore`,
  detailsDashboard: `/dashboard/Details`,

  //ministry urls

  ministry: `/ministry`,
  editMinistry: `/ministry/edit`,
  addMinistry: `/ministry/add`,
  detailsMinistry: `/ministry/details`,

  //provinces urls

  provinces: `/provinces`,
  provincesDetails: `/provinces/details`,

  //district's urls

  districts: `/districts`,
  districtsDetails: `/districts/details`,

  //pou urls

  pou: `/clinics`,
  pouDetail: `/pou/details`,

  //batches urls

  batch: `/vaccines`,
  dashboardDetails: `/dashboard/details`,

  //settings

  setting: `/setting`,
  changePasswordAdmin: `/setting/changePassword`,

  //categories

  categories: "/categories",
  addCategory: "/category/add",
  editCategory: "/category/edit",

  //products

  products: "/products",
  addProduct: "/product/add",
  editProduct: "/product/edit",
};

//ministry urls

export const ministryRoutes = {
  //dashboard urls

  root: `/`,
  dashboard: `/dashboard`,
  dashboardDetails: `/dashboard/details`,
  dashbordSeeMore: `/dashboard/SeeMore`,

  //provinces urls

  provinces: `/provincial`,
  addProvince: `/provincial/add`,
  editProvince: `/provinces/edit`,
  detailsProvince: `/provinces/details`,

  //district urls

  districts: `/districts`,
  detailsDistrict: `/districts/details`,

  //pou urls

  pointOfUse: `/clinics`,
  detailsPou: `/pou/details`,

  //batch's urls

  batch: `/vaccines`,
  issuedBatch: `/batch/issued`,
  issuedBatchManually: `/batch/issueManually`,
  retireBatch: `/batch/retire`,
  create_batch: `/batch/create`,
  request_inventory: `/batch/CreateRequest`,
  units_used: `/batch/unitsUsed`,
  // Request Urls

  requests: `/requests`,
  receiveInventory: `/requests/receiveInventory`,

  //settings urls

  setting: `/setting`,
  changePassword: `/setting/ChangePassword`,

  // Nodes

  nodeView: `/nodeView`,
};

//provinces urls

export const provinceRoutes = {
  //dashboard urls

  root: `/`,
  dashboard: `/dashboard`,
  requestDetails: `/dashboard/details`,
  requestRecieved: `/dashboard/received`,

  //districts urls

  districts: `/districts`,
  addDistrict: `/districts/add`,
  editDistrict: `/districts/edit`,
  detailsDistrict: `/districts/details`,

  //pou urls

  pointOfUse: `/clinics`,
  pouDetails: `/pou/details`,

  //batch urls

  batch: `/vaccines`,
  issuedBatch: `/batch/issued`,
  issuedBatchManually: `/batch/issueManually`,
  retireBatch: `/batch/retire`,
  create_batch: `/batch/create`,
  request_inventory: `/batch/CreateRequest`,
  units_used: `/batch/unitsUsed`,

  // Request Urls

  requests: `/requests`,
  receiveInventory: `/requests/receiveInventory`,

  //settings urls

  setting: `/setting`,
  changePassword: `/setting/changePassword`,
};

//district urls

export const districtRoutes = {
  //dashboard urls

  root: `/`,
  dashboard: `/dashboard`,
  dashboardDetails: `/dashboard/details`,
  dashbordSeeMore: `/dashboard/SeeMore`,

  //pou urls

  pou: `/clinics`,
  poudetails: `/pou/details`,
  editPou: `/pou/edit`,
  addPou: `/clinics/add`,

  //batch's urls

  batch: `/vaccines`,
  issuedBatch: `/batch/issued`,
  issuedBatchManually: `/batch/issueManually`,
  retireBatch: `/batch/retire`,
  create_batch: `/batch/create`,
  request_inventory: `/batch/CreateRequest`,
  units_used: `/batch/unitsUsed`,

  // Request Urls

  requests: `/requests`,
  receiveInventory: `/requests/receiveInventory`,

  //settings urls

  setting: `/setting`,
  changePassword: `/setting/ChangePassword`,
};

//pou urls

export const pouRoutes = {
  //dashboard urls

  dashboard: `/dashboard`,
  dashboardDetails: `/dashboard/details`,
  dashbordSeeMore: `/dashboard/SeeMore`,

  //batch's urls

  batch: `/vaccines`,
  issuedBatch: `/batch/issued`,
  issuedBatchManually: `/batch/issueManually`,
  retireBatch: `/batch/retire`,
  request_inventory: `/batch/CreateRequest`,

  // requests
  requests: `/requests`,
  receiveInventory: `/requests/receiveInventory`,

  //settings urls

  setting: `/setting`,
  changePassword: `/setting/changePassword`,
};

// common routes

export const commonRoutes = {
  batch: {
    details: `/batch/details`,
    issuedManually: `/batch/issueManually`,
  },
  transactions: `/batch/transactions`,
  batches: `/batches`,
  request: `/request`,
  requests: {
    receiveInventory: `/requests/receiveInventory`,
  },
  node: {
    details: `/node/details`,
  },
  details: `/details`,
  nodeView: `/nodeView`,
};
